module.exports = __webpack_public_path__ + "static/media/buttonclick.f464ffcf.wav";